// @ah/videos shared GraphQL queries — used by desktop and mobile.

export const RECOMMENDED_VIDEOS_QUERY = /* GraphQL */ `
  query RecommendedVideos {
    recommendedVideos(limit: 20) {
      id
      youtubeId
      title
      description
      imageUrl
      duration
      viewCount
      datePublished
      summaryGeneratedAt
      summary {
        hook
        topics
      }
      channel {
        id
        title
        imageUrl
      }
    }
  }
`;

export const VIDEOS_LIST_QUERY = /* GraphQL */ `
  query VideosList {
    videos(limit: 30) {
      id
      youtubeId
      title
      description
      imageUrl
      duration
      viewCount
      datePublished
      summaryGeneratedAt
      summary {
        hook
        topics
      }
      channel {
        id
        title
        imageUrl
      }
    }
  }
`;

export const VIDEO_CHANNELS_QUERY = /* GraphQL */ `
  query VideoChannelsList {
    videoChannels(limit: 20) {
      id
      youtubeId
      title
      handle
      description
      imageUrl
      subscriberCount
      videoCount
    }
  }
`;

export const VIDEO_CHANNEL_DETAIL_QUERY = /* GraphQL */ `
  query VideoChannelDetail($id: ID!) {
    videoChannelById(id: $id) {
      id
      youtubeId
      title
      handle
      description
      imageUrl
      subscriberCount
      videoCount
      latestVideos(limit: 30) {
        id
        youtubeId
        title
        description
        imageUrl
        duration
        viewCount
        datePublished
        summaryGeneratedAt
        summary { hook topics }
        channel { id title imageUrl }
      }
    }
  }
`;

const VIDEO_LIST_FIELDS = /* GraphQL */ `
  id
  youtubeId
  title
  description
  imageUrl
  duration
  viewCount
  datePublished
  summaryGeneratedAt
  summary { hook topics }
  channel { id title imageUrl }
`;

export const RECENTLY_WATCHED_VIDEOS_QUERY = /* GraphQL */ `
  query RecentlyWatchedVideos($limit: Int) {
    recentlyWatchedVideos(limit: $limit) { ${VIDEO_LIST_FIELDS} }
  }
`;

export const SAVED_VIDEOS_QUERY = /* GraphQL */ `
  query SavedVideos($limit: Int) {
    savedVideos(limit: $limit) { ${VIDEO_LIST_FIELDS} }
  }
`;

export const RECORD_VIDEO_ENGAGEMENT_MUTATION = /* GraphQL */ `
  mutation RecordVideoEngagement($id: ID!) {
    recordVideoEngagement(id: $id)
  }
`;

export const RECORD_VIDEO_SAVE_MUTATION = /* GraphQL */ `
  mutation RecordVideoSave($id: ID!) {
    recordVideoSave(id: $id)
  }
`;

export const RECORD_VIDEO_UNSAVE_MUTATION = /* GraphQL */ `
  mutation RecordVideoUnsave($id: ID!) {
    recordVideoUnsave(id: $id)
  }
`;

export const VIDEO_DETAIL_QUERY = /* GraphQL */ `
  query VideoDetail($id: ID!) {
    video(id: $id) {
      id
      youtubeId
      title
      description
      imageUrl
      duration
      viewCount
      datePublished
      transcriptStatus
      summaryStatus
      summaryGeneratedAt
      summary {
        hook
        whatItsAbout
        eli5
        longRead
        keyTakeaways
        keyConcepts { term wikipediaQuery why }
        keySpeakers { name bio }
        keyIdeas { title body }
        keyQuotes { quote speaker timestampSec }
        whyItMatters
        chapters { title startSec body }
        topics
      }
      channel {
        id
        title
        imageUrl
      }
      isSaved
    }
  }
`;
